import { InputNumber, Slider } from "antd";

const FilterTray = ({
  closeTray,
  filterOption,
  setFilterOption,
  availableGenders,
  gender,
  category,
  subCategory,
  subSubCategory,
  displaySubCatMap,
  range,
  size,
  alphabeticSizes,
  availableSizes,
  numericSizes,
  sortBy,
  sortOptions,
  setSortBy,
  handleGenderChange,
  handleCategoryChange,
  handleSubCategoryChange,
  handleRangeChange,
  handleMinInputChange,
  handleMaxInputChange,
  handleSizeChange,
  handleClose,
  resetBrandFilter,
  handleApplyFilter,
  handleBrandChange,
  brands,
  selectedBrands,
  type,
}) => {
  const FilterOption = (option, text) => {
    return (
      <div
        onClick={() => setFilterOption(option)}
        style={{
          cursor: "pointer",
          backgroundColor: filterOption === option ? "#F4F9FF" : "white",
          height: "38px",
          padding: "4px 12px",
          color: filterOption === option ? "#005FDA" : "black",
          borderRadius: "4px",
        }}
        className="d-flex align-items-center justify-content-center"
      >
        {text}
      </div>
    );
  };
  const selectedOptionDivHeading = (text) => {
    return (
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: "500",
          fontSize: "16px",
          color: "black",
          marginBottom: "12px",
        }}
      >
        {text}
      </div>
    );
  };
  return (
    <>
      <style jsx>
        {`
          .selected {
            background-color: rgb(0, 95, 218);
            color: white;
          }
        `}
      </style>
      <div
        className="d-flex flex-column w-100"
        style={{
          minHeight: "40vh",
          marginTop: "12px",
          gap: "12px",
        }}
      >
        <div
          className="d-flex align-items-center hiddenScrollbar bg-white"
          style={{
            overflowX: "auto",
            whiteSpace: "nowrap",
            padding: "2px",
            borderRadius: "8px",
            gap: "12px",
          }}
        >
          {type === "AllProducts" ? (
            <>{FilterOption("brands", "Brands")}</>
          ) : (
            <>
              {FilterOption("gender", "Gender")}
              {FilterOption("category", "Category")}
              {FilterOption("subCategory", "Sub-Category")}
            </>
          )}

          {FilterOption("price", "Price")}
          {FilterOption("size", "Size")}
          {FilterOption("sort", "Sort By")}
        </div>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "12px 6px",
            height: "32vh",
          }}
        >
          {filterOption === "brands" && (
            <>
              {selectedOptionDivHeading("Brands")}
              <div
                className="row gap-3 mx-0 p-1"
                style={{ overflowY: "auto", height: "25vh" }}
              >
                {brands?.map((brand) => (
                  <div
                    key={brand.id}
                    style={{
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                      outline: "1px solid #C3C3C3",
                    }}
                    className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${selectedBrands.includes(
                      brand.id
                    ) && "selected"}`}
                    onClick={() => handleBrandChange(brand.id)}
                  >
                    {brand.displayName}
                  </div>
                ))}
              </div>
            </>
          )}
          {filterOption === "gender" && (
            <>
              {selectedOptionDivHeading("Gender")}
              <div className="row gap-3 mx-0 p-1">
                <div
                  style={{
                    whiteSpace: "nowrap",
                    cursor: availableGenders.includes("Men")
                      ? "pointer"
                      : "default",
                    outline: "1px solid #C3C3C3",
                    opacity: availableGenders.includes("Men") ? 1 : 0.5,
                  }}
                  className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${gender.includes(
                    "Men"
                  ) && "selected"}`}
                  onClick={() => {
                    if (availableGenders.includes("Men"))
                      handleGenderChange("Men");
                  }}
                >
                  Men
                </div>

                <div
                  style={{
                    whiteSpace: "nowrap",
                    cursor: availableGenders.includes("Women")
                      ? "pointer"
                      : "default",
                    outline: "1px solid #C3C3C3",
                    opacity: availableGenders.includes("Women") ? 1 : 0.5,
                  }}
                  className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${gender.includes(
                    "Women"
                  ) && "selected"}`}
                  onClick={() => {
                    if (availableGenders.includes("Women"))
                      handleGenderChange("Women");
                  }}
                >
                  Women
                </div>
              </div>
            </>
          )}
          {filterOption === "category" && (
            <>
              {selectedOptionDivHeading("Category")}
              <div className="row gap-3 mx-0 p-1">
                <div
                  style={{
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    outline: "1px solid #C3C3C3",
                  }}
                  className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${category.includes(
                    "Ready to Wear"
                  ) && "selected"}`}
                  onClick={() => handleCategoryChange("Ready to Wear")}
                >
                  Ready to Wear
                </div>
                <div
                  style={{
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    outline: "1px solid #C3C3C3",
                  }}
                  className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${category.includes(
                    "Unstitched"
                  ) && "selected"}`}
                  onClick={() => handleCategoryChange("Unstitched")}
                >
                  Unstitched
                </div>
                <div
                  style={{
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    outline: "1px solid #C3C3C3",
                  }}
                  className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${category.includes(
                    "Western Wear"
                  ) && "selected"}`}
                  onClick={() => handleCategoryChange("Western Wear")}
                >
                  Western Wear
                </div>
              </div>
            </>
          )}
          {filterOption === "subCategory" && (
            <>
              {selectedOptionDivHeading("Sub-Category")}
              <div
                className="row gap-3 mx-0 p-1"
                style={{ overflowY: "auto", height: "25vh" }}
              >
                {subSubCategory?.map((subCat) => (
                  <div
                    key={subCat}
                    style={{
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                      outline: "1px solid #C3C3C3",
                    }}
                    className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${subCategory.includes(
                      subCat
                    ) && "selected"}`}
                    onClick={() => handleSubCategoryChange(subCat)}
                  >
                    {displaySubCatMap[subCat]}
                  </div>
                ))}
              </div>
            </>
          )}
          {filterOption === "price" && (
            <>
              {selectedOptionDivHeading("Price")}
              <div className="flex-1 justify-content-center p-1">
                <div className="rounded-3 mb-3">
                  <Slider
                    range
                    value={range}
                    onChange={handleRangeChange}
                    min={0}
                    max={90000}
                    step={500}
                    tipFormatter={(value) => `${value}`}
                  />
                </div>

                <div className="row mx-0 gap-2 w-100">
                  <div className="col">
                    <label>Min</label>
                    <InputNumber
                      className="w-100"
                      min={0}
                      max={90000}
                      value={range[0]}
                      onChange={handleMinInputChange}
                      placeholder={range[0]}
                    />
                  </div>
                  <div className="col">
                    <label>Max</label>
                    <InputNumber
                      className="w-100"
                      min={0}
                      max={90000}
                      value={range[1]}
                      onChange={handleMaxInputChange}
                      placeholder={range[1]}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {filterOption === "size" && (
            <>
              {selectedOptionDivHeading("Size")}
              <div className="row gap-3 mx-0 p-1">
                {alphabeticSizes &&
                  alphabeticSizes?.map((s) => (
                    <div
                      key={s}
                      style={{
                        whiteSpace: "nowrap",
                        cursor: availableSizes.includes(s)
                          ? "pointer"
                          : "default",
                        outline: "1px solid #C3C3C3",
                        opacity: availableSizes.includes(s) ? 1 : 0.5,
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${size.includes(
                        s
                      ) && "selected"}`}
                      onClick={() => {
                        if (availableSizes.includes(s)) handleSizeChange(s);
                      }}
                    >
                      {s}
                    </div>
                  ))}
                {numericSizes &&
                  numericSizes?.map((s) => (
                    <div
                      key={s}
                      style={{
                        whiteSpace: "nowrap",
                        cursor: numericSizes.includes(s)
                          ? "pointer"
                          : "default",
                        outline: "1px solid #C3C3C3",
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${size.includes(
                        s
                      ) && "selected"}`}
                      onClick={() => {
                        if (numericSizes.includes(s)) handleSizeChange(s);
                      }}
                    >
                      {s}
                    </div>
                  ))}
              </div>
            </>
          )}
          {filterOption === "sort" && (
            <>
              {selectedOptionDivHeading("Sort By")}
              <div className="row gap-3 mx-0 p-1">
                {sortOptions &&
                  sortOptions?.map((option) => (
                    <div
                      key={option.value}
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        outline: "1px solid #C3C3C3",
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${sortBy ===
                        option.value && "selected"}`}
                      onClick={() => {
                        setSortBy(option.value);
                      }}
                    >
                      {option.name}
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="d-flex flex-column w-100" style={{ gap: "8px" }}>
        <div
          className="w-100 d-flex justify-content-center align-items-center"
          style={{
            borderRadius: "8px",
            height: "42px",
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "14px",
            cursor: "pointer",
            backgroundColor: "#005FDA",
            color: "white",
          }}
          onClick={async () => {
            handleApplyFilter();
            handleClose();
          }}
        >
          Apply
        </div>

        <div
          className="w-100 d-flex justify-content-center align-items-center"
          style={{
            borderRadius: "8px",
            height: "42px",
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "14px",
            cursor: "pointer",
            backgroundColor: "white",
            color: "#676A79",
          }}
          onClick={() => {
            //Reset Modal function
            resetBrandFilter();
          }}
        >
          Reset
        </div>
      </div>
    </>
  );
};

export default FilterTray;
